import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { SubscriptionTier } from '@/actions/dtos/subscription';
import { useAccount } from '@/hooks/useAccount';
import { useAuthenticated } from '@/hooks/useAuthenticated';
import { useDispatch } from 'react-redux';
import { FeatureType, openModal } from '@/slices/features/modalSlice';
import Button from '@/components/common/Button';

interface QuickCopyButtonProps {
  text: string;
}

const QuickCopyButton: React.FC<QuickCopyButtonProps> = ({ text }) => {
  const { currentTier } = useAccount();
  const { isAuthenticated } = useAuthenticated();
  const [hasPermissionToCopy, setHasPermissionToCopy] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setHasPermissionToCopy(isAuthenticated && currentTier !== SubscriptionTier.BASIC);
  }, [isAuthenticated, currentTier]);

  const copyTextToClipboard = () => {
    if (hasPermissionToCopy) {
      navigator.clipboard.writeText(text);
      toast.success('Kopiert!');
    } else {
      dispatch(openModal(FeatureType.QUICK_COPY));
    }
  };

  return (
    <span onClick={copyTextToClipboard}>
      <Button
        variant={'primary'}
        icon={faCopy}
        buttonClassName={`border-none w-10 h-7 btn-xs`}
        locked={!hasPermissionToCopy}
      />
    </span>
  );
};

export default QuickCopyButton;
